export default {
  methods: {
    openBeacon (beaconId) {
      if (this.beacon) {
        window.Beacon('reset')
        window.Beacon('destroy')
      }
      this.beacon = true
      window.Beacon('init', beaconId)
      window.Beacon('open')
    },

    showBeaconMessage (beaconId, messageId) {
      if (this.beacon) {
        window.Beacon('reset')
        window.Beacon('destroy')
      }
      this.beacon = true
      window.Beacon('init', beaconId)
      window.Beacon('show-message', messageId, { force: true, delay: 10 })
    } 
  },

  mounted () {
    if (this.$route.query.customerName && this.$route.query.customerEmail) {
      window.Beacon('identify', {
        name: this.$route.query.customerName,
        email: this.$route.query.customerEmail
      })
    }
  }
}